import Logo from "@/assets/header/Logo.svg?react";

interface BrandLoadingScreenProps {
  message?: string;
  dataTestId?: string;
}

export const BrandLoadingScreen = ({
  message,
  dataTestId = "brand-loading-screen",
}: BrandLoadingScreenProps) => (
  <div
    data-testid={dataTestId}
    className="fixed inset-0 z-[99] flex min-h-screen flex-col items-center justify-center bg-background-secondary"
  >
    <Logo
      data-testid="brand-loading-logo"
      className="h-10 w-auto animate-pulse desktop:h-12"
      aria-hidden
    />
    {message && (
      <p className="mt-8 text-center text-body-base font-semibold text-foreground-primary">
        {message}
      </p>
    )}
  </div>
);
